import React from 'react';
import { ConfirmationDelete } from 'components/Dialogs';

const MESSAGE = '';
const DeleteRangeSensitivityDialog = () => (
  <ConfirmationDelete itemName="range sensitivity" customMessage={MESSAGE} />
);

export default DeleteRangeSensitivityDialog;
